<div class="container-modal-lateral">
  <div>
    <div class="flex-direction-row justify-between align-center">
      <span class="title-modal-lateral">{{ isCadastro ? 'Novo custo WhatsApp' : 'Editar custo WhatsApp' }}</span>
      <mat-icon class="cursor-pointer" (click)="cancelar()">close</mat-icon>
    </div>

    <div class="main-modal-lateral-edicao">
      <app-select-one
        label="País"
        widthFormField="100%"
        heightFormField="35px"
        campo="nome"
        [listaInput]="opcoesPais"
        [itemSelecionado]="obterPais()"
        (selecionarItem)="selecionarPais($event)">
      </app-select-one>

      <app-select-one
        label="Categoria de cobrança"
        widthFormField="100%"
        heightFormField="35px"
        campo="nome"
        [listaInput]="opcoesCategoria"
        [itemSelecionado]="obterCategoria()"
        (selecionarItem)="selecionarCategoria($event)">
      </app-select-one>

      <form [formGroup]="formCusto" class="flex-direction-column gap-15" (ngSubmit)="salvar()">
        <app-form-field
          label="Custo"
          heightFormField="35px"
          type="number"
          [textPrefix]="obterMoeda()?.id"
          [step]="0.0001"
          [min]="0"
          placeholder="0.0000"
          formControlName="custo">
        </app-form-field>

        <app-select-one
          label="Moeda"
          widthFormField="100%"
          heightFormField="35px"
          campo="nome"
          [listaInput]="opcoesMoeda"
          [itemSelecionado]="obterMoeda()"
          (selecionarItem)="selecionarMoeda($event)">
        </app-select-one>
      </form>

      @if (!isCadastro) {
        <div class="container-info-modal-lateral">
          <span class="label">Criado por</span>
          <span class="font-12 ellipse">{{ custo.createdByNome || '-' }} em {{ (custo.createdAt | date:'dd/MM/yyyy HH:mm') || '-' }}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Alterado por</span>
          <span class="font-12 ellipse">{{ custo.updatedByNome || '-' }} em {{ (custo.updateAt | date:'dd/MM/yyyy HH:mm') || '-' }}</span>
        </div>
      }
    </div>
  </div>

  <div class="botoes-modal-lateral">
    <app-button-padrao
      width="100%"
      label="Salvar"
      backgroundColor="var(--verde-padrao)"
      color="white"
      [type]="'submit'"
      (buttonClick)="salvar()">
    </app-button-padrao>
    <app-button-padrao
      width="100%"
      label="Cancelar"
      backgroundColor="white"
      color="var(--vermelho-padrao)"
      borderColor="var(--vermelho-padrao)"
      borderStyle="solid"
      borderWidth="1px"
      (buttonClick)="cancelar()">
    </app-button-padrao>
  </div>
</div>
